import BulkEmailForm from './js/BulkEmailForm';

export default BulkEmailForm;
